import DeleteCampaignForm from './DeleteCampaignForm';

export default DeleteCampaignForm;
